import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '@lucca-front/ng/button';

import { AppStore } from '@src/app-store';

@Component({
  imports: [ButtonComponent],
  selector: 'app-rules',
  templateUrl: './app-rules.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppRules {
  readonly store = inject(AppStore);

  showRules = false;

  toggleRules() {
    this.showRules = !this.showRules;
  }
}
